var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { class: ["box", _vm.status] }, [
      _c("div", { staticClass: "columns is-vcentered is-marginless" }, [
        _c(
          "div",
          { staticClass: "column is-narrow" },
          [
            _c("dc-icon", {
              attrs: {
                library: "fas",
                icon: "file-pdf",
                size: "lg",
                "no-margin": "",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column" },
          [
            _c("form-text", {
              attrs: { placeholder: "File title", name: _vm.titleName },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column is-narrow" },
          [
            _c("dc-icon", {
              staticClass: "move-icon",
              attrs: { icon: "bars", size: "lg" },
            }),
            _c(
              "span",
              { on: { click: _vm.onDelete } },
              [
                _c("dc-icon", {
                  staticClass: "delete-icon",
                  attrs: { icon: "trash-alt", size: "lg", "no-margin": "" },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "p",
        {
          staticClass: "file-message",
          class: { "has-text-danger": !_vm.title },
        },
        [_vm._v(" " + _vm._s(_vm.filemessage) + " ")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }